export const roles = [
  {
    Feature: "Job Create",
    "Role id": "job.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide",
    "Query Backend": "Disable",
    Notes: "",
  },
  {
    Feature: "Job Delete",
    "Role id": "job.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide",
    "Query Backend": "Disable",
    Notes: "",
  },
  {
    Feature: "Job Edit",
    "Role id": "job.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI":
      "No totals, rates, hide global and flat, cant add leg, disable pencil edit",
    "Query Backend": "No totals, rates, hide global and flat, cant add leg",
    Notes: "",
  },
  {
    Feature: "Job Read",
    "Role id": "job.read",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: 1,
    "Fallback UI": "No accessory totals",
    "Query Backend": "No totals, rates",
    Notes: "Future proofing disable job show link",
  },
  {
    Feature: "",
    "Role id": "",
    "Account Holder": "",
    Admin: "",
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Leg Create",
    "Role id": "leg.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide",
    "Query Backend": "Disable",
    Notes: "",
  },
  {
    Feature: "Leg Delete",
    "Role id": "leg.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide",
    "Query Backend": "Disable",
    Notes: "",
  },
  {
    Feature: "Leg Edit",
    "Role id": "leg.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide, disable orderNumber link",
    "Query Backend": "Hide",
    Notes: "",
  },
  {
    Feature: "Leg Read",
    "Role id": "leg.read",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: 1,
    "Fallback UI": "Remove totals",
    "Query Backend": "Remove totals",
    Notes: "",
  },
  {
    Feature: "Invoice Create",
    "Role id": "invoice.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Invoice Delete",
    "Role id": "invoice.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Invoice Edit",
    "Role id": "invoice.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Invoice Read",
    "Role id": "invoice.read",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Remove invoice from menu",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Manifest Create",
    "Role id": "manifest.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Manifest Delete",
    "Role id": "manifest.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Manifest Edit",
    "Role id": "manifest.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Manifest Read",
    "Role id": "manifest.read",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Payout Create",
    "Role id": "payout.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Payout Delete",
    "Role id": "payout.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Payout Edit",
    "Role id": "payout.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Payout Read",
    "Role id": "payout.read",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: 1,
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Client Create",
    "Role id": "client.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Client Delete",
    "Role id": "client.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Client Edit",
    "Role id": "client.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Client Read",
    "Role id": "client.read",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: "",
    Client: "",
    "Fallback UI": "Remove settings",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Driver Create",
    "Role id": "driver.create",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "hide",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Driver Delete",
    "Role id": "driver.delete",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "hide",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Driver Edit",
    "Role id": "driver.edit",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: 1,
    Client: "",
    "Fallback UI": "Set to relative id, remove rates",
    "Query Backend": "Set to relative id, remove rates",
    Notes: "",
  },
  {
    Feature: "Driver Read",
    "Role id": "driver.read",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: "",
    "Fallback UI": "Set to relative id, remove rates",
    "Query Backend": "Set to relative id, remove rates",
    Notes: "",
  },
  {
    Feature: "Settings Read",
    "Role id": "settings.read",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Hide",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "",
    "Role id": "",
    "Account Holder": "",
    Admin: "",
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "",
    "Role id": "",
    "Account Holder": "",
    Admin: "",
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Dashboard Totals",
    "Role id": "dashboard.totals",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI": "Total Jobs",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Dashboard Jobs Table",
    "Role id": "dashboard.jobs.table",
    "Account Holder": 1,
    Admin: 1,
    User: "",
    Driver: "",
    Client: "",
    "Fallback UI":
      "Remove total charges, show only jobs to relative id. Only show drivers jobs, only show clients jobs",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Dashboard Jobs Status Graph",
    "Role id": "dashboard.jobs.status.graph",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: 1,
    "Fallback UI": "Send relative id with query",
    "Query Backend": "",
    Notes: "",
  },
  {
    Feature: "Jobs Index",
    "Role id": "jobs.table",
    "Account Holder": 1,
    Admin: 1,
    User: 1,
    Driver: 1,
    Client: 1,
    "Fallback UI": "Remove total charges, invoice, notes",
    "Query Backend": "Remove total charges, invoice, notes",
    Notes: "",
  },
];
